// extracted by mini-css-extract-plugin
export const note = "note-module--note--17cFf";